import baseSingleUserField from "../SingleUserField/BaseSingleUserField";

export default {
    mixins:[baseSingleUserField],
    computed:{
        selectItems:function(){
            return this.userOptions.filter(x=> (this.data[this.name] || []).includes(x.name));
        },
        valueString:function(){
            return JSON.stringify(this.data[this.name]);
        }
    },
    methods:{
        initValue:function(){
            this.data[this.name] = [];
        },

        setValueBeforeHook: function(value1) {
            if(Array.isArray(value1)){
                return value1;
            }
            else{
                return [value1];
            }
        }
    }
}